<template>
  <div>
    <t-card class="card_common" v-loading="showFlag">
      <div>
        <t-row>
          <t-col :span="8" class="col_common_center">
            <!-- 新規 -->
            <t-button
              round
              type="primary"
              ref="addBtn"
              class="button_common"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.sys.newBuilt") }}
            </t-button>
          </t-col>

          <t-col :span="8" class="col_common_center">
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              ref="delBtn"
              class="button_common"
              @click="deleteClickSelected"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button>
          </t-col>
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
              @submit.native.prevent
            >
              <t-row>
                <t-col :span="parseInt($t('widgetSize.search.spaceSpan'))"
                  >&nbsp;</t-col
                >
                <t-col
                  :span="parseInt($t('widgetSize.search.searchKeySpan'))"
                  class="col_common_searchKey"
                >
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      clearable
                      maxLength="50"
                      class="input_searchKey"
                    >
                    </t-input>
                  </t-form-item>
                </t-col>
                <t-col
                  :span="parseInt($t('widgetSize.search.searchSpaceSpan'))"
                  class="col_common_searchKey"
                  >&nbsp;</t-col
                >
                <t-col
                  :span="parseInt($t('widgetSize.search.searchBtnSpan'))"
                  class="col_common_search"
                >
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search"
                    ref="searchBtn"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <div class="div_content">
        <t-table
          ref="customerInfoTableData"
          :data="customerInfoTableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="updateClick"
          :height="maxheight"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :width="column.realWidth"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>

        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="tableDatalength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>

<script>
import { ShowCustomerEditDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { DeleteCusMstInfo, GetCusMstInfo } from "@/services/customerInfo";
import { GetPageDataCount } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";

export default {
  data() {
    return {
      searchConditionForm: {
        searchWord: "",
      },

      showFlag: true,

      // 現在のページ数
      pageNo: 1,
      // データ個数/各ページ
      pageSize: 20,

      customerInfoData: [],

      tableDatalength: 0,

      maxheight: window.innerHeight - 291.5 + 35,

      columns: [
        // 得意先コード
        {
          prop: "cusCode",
          label: t("resource.customerInfo.cusCode"),
          realWidth: t("widgetSize.tableCommon.width120"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // 得意先名
        {
          prop: "cusName",
          label: t("resource.customerInfo.cusName"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 得意先略称
        {
          prop: "cusAbbreviation",
          label: t("resource.customerInfo.abbreviation"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // アドレス
        // {
        //   prop: "cusAdd",
        //   label: t("resource.customerInfo.cusAddress"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: false,
        // },

        // TEL
        {
          prop: "cusTel",
          label: t("resource.customerInfo.cusTel"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // FAX
        {
          prop: "cusFax",
          label: t("resource.customerInfo.cusFax"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 郵便番号
        {
          prop: "cusZipCode",
          label: t("resource.customerInfo.cusZipCode"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        /*
        // 連絡先
        {
          prop: "cusContacts",
          label: t("resource.customerInfo.cusContacts"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: false,
        },

        // 連絡先TEL
        {
          prop: "cusContactsTel",
          label: t("resource.customerInfo.cusContactsTel"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },

        // 連絡先Mail
        {
          prop: "cusContactsMail",
          label: t("resource.customerInfo.cusContactsMail"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },*/
        // 締め日
        {
          prop: "cusCalculateDate",
          label: t("resource.customerInfo.cusCalculateDate"),
          realWidth: t("widgetSize.tableCommon.width120"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
        // 終了日
        {
          prop: "cusEndDate",
          label: t("resource.customerInfo.endDate"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: true,
        },
      ],
    };
  },

  mounted() {
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  computed: {
    customerInfoTableData: {
      get() {
        return this.customerInfoData.slice(
          (this.pageNo - 1) * this.pageSize,
          this.pageNo * this.pageSize
        );
      },
    },
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      this.searchClick();
    },
    // 検索
    searchClick() {
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord.trim();

      GetCusMstInfo(this.searchConditionForm.searchWord)
        .then((res) => {
          this.customerInfoData = res;

          this.tableDatalength = this.customerInfoData.length;

          setColumnWidth(this.columns, this.customerInfoData);

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });

      if (typeof this.$refs.searchBtn !== "undefined") {
        // フォーカス削除
        this.$refs.searchBtn.$el.blur();
      }
    },

    // 得意先新規画面
    addClick() {
      ShowCustomerEditDialog(
        { isAdd: true },
        t("resource.customerInfo.cusCreateView"),
        (target) => {
          this.init();
        }
      );

      // フォーカス削除
      this.$refs.addBtn.$el.blur();
    },
    //得意先編集画面
    updateClick(row) {
      ShowCustomerEditDialog(
        { isAdd: false, rowData: row },
        t("resource.customerInfo.cusEditView"),
        (target) => {
          this.init();
        }
      );
    },

    //複数行データの削除
    deleteClickSelected() {
      let data = this.$refs.customerInfoTableData.selection;

      if (data.length >= 1) {
        Modal.showWarning("", t("message.COMMON_MESSAGE.DELETE_CONFIRM_MSG"), {
          $type: "prompt",
          confirmButtonText: t("resource.button.sure"),
          cancelButtonText: t("resource.button.cancel"),
          showCancelButton: true,
        })
          .then(() => {
            DeleteCusMstInfo(data)
              .then(() => {
                this.init();

                Message.showSuccess(
                  t("message.COMMON_MESSAGE.DELETE_SUCCESS"),
                  null
                );
              })
              .catch((error) => {
                if (error.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
              });
          })
          .catch((error) => {});
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"))
          .then(() => {})
          .catch((error) => {
            console.error(error);
          });
      }

      // フォーカス削除
      this.$refs.delBtn.$el.blur();
    },

    //テーブルの高さを設定する
    handleResize() {
      this.maxheight = window.innerHeight - 291.5 + 35; //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6
    },

    // 翻页处理
    pageChange(val) {
      this.pageNo = val;
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },

    // 每页数据条数
    getPageDataCountFunc() {
      return GetPageDataCount();
    },

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.customerTableData);
    },
  },
};
</script>
